(function() {
  'use strict';
  angular.module('app.maps')
    .controller('LoaderCtrl', ['$scope', 'Loader', '$timeout', function($scope, Loader, $timeout) {
      $scope.enabled = Loader.state;
      $scope.firstload = true;

      $scope.$on('loader:toggled', function() {
        if ($scope.firstload === false) {
          $scope.enabled = Loader.state;
        } else {
          $timeout($scope.enabled = Loader.state);
        }
      });
    }]);
}());
